import { Component, inject } from '@angular/core';
import { ViaSapTransportService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ViaSapTransportCreateDto,
  ViaSapTransportDto,
  ViaSapTransportExcelDownloadDto,
  ViaSapTransportUpdateDto,
} from '../proxy/controlling/dtos/via-sap-transport';
import { VIASAPTRANSPORT_CONFIG, VIASAPTRANSPORT_FIELDS } from './via-sap-transport.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-via-sap-transport',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ViaSapTransportService, ConfirmationService],
  templateUrl: './via-sap-transport.html',
  styleUrl: './via-sap-transport.scss',
})
export class ViaSapTransport extends BaseCrudComponent<
  ViaSapTransportDto,
  ViaSapTransportCreateDto,
  ViaSapTransportUpdateDto,
  ViaSapTransportExcelDownloadDto
> {
  service = inject(ViaSapTransportService);
  config = VIASAPTRANSPORT_CONFIG;
  fields = VIASAPTRANSPORT_FIELDS;

  protected prepareUpdateDto(data: any, selected: ViaSapTransportDto): ViaSapTransportUpdateDto {
    return {
      name: data.name,
      value: data.value,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ViaSapTransport';
  }
}
